import { createContext, FC, useContext, useState } from 'react';
import { Breakpoint, breakpoints } from 'utils/mediaQuery';
import { useWindowEvent } from 'hooks/useWindowEvent';

type BreakpointContextProps = {
    breakpoint: Breakpoint;
};

export const BreakpointContext = createContext<BreakpointContextProps>({
    breakpoint: 'L'
});

const getBreakpoint = (): Breakpoint => {
    const width = window.innerWidth;

    return Object.keys(breakpoints).find(
        (key) => width >= breakpoints[key as Breakpoint]
    ) as Breakpoint;
};

export const useScreenLessThan = (breakpoint: Breakpoint) => {
    const { breakpoint: currentBreakpoint } = useContext(BreakpointContext);

    return breakpoints[breakpoint] >= breakpoints[currentBreakpoint];
};

export const useScreenGreaterThan = (breakpoint: Breakpoint) => {
    const { breakpoint: currentBreakpoint } = useContext(BreakpointContext);

    return breakpoints[breakpoint] < breakpoints[currentBreakpoint];
};

export const useNotDesktop = () => {
    const result = useScreenLessThan('M');

    return result;
};

export const BreakpointProvider: FC<ChildrenProps> = ({ children }) => {
    const [breakpoint, setBreakpoint] = useState<Breakpoint>(getBreakpoint());

    useWindowEvent('resize', () => {
        setBreakpoint(getBreakpoint());
    });

    return (
        <BreakpointContext.Provider value={{ breakpoint }}>
            {children}
        </BreakpointContext.Provider>
    );
};
